import React, { useEffect, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { SelectableModalProps } from '../../../../../../components/types';
import FollowUp from '../../../../../../components/FollowUp';
import { getMessages } from '../../../../../../services/followup';
import MessageSender from '../../../../../../components/MessageSender';
import { maskCpfOrCnpj } from '../../../../../../services/masks';
import styled from 'styled-components';
import moment from 'moment-timezone';

const InfoContainer = styled.div`
  width: 100%;

  background-color: #f7f0eb;
  padding: 1rem;
  border-radius: 6px;

  display: flex;
  flex-direction: column;

  > div {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.35rem;

    > div {
      flex: 1;
    }
  }
`;

export type FollowUpModalProps = {
  id: string;
  claim: any;
  isBlocked?: boolean;
};

const FollowUpTab = (props: FollowUpModalProps) => {
  const { id, claim } = props; // , setUnread, unread
  const {
    propertyStreet,
    propertyNumber,
    propertyComplement,
    propertyDistrict,
    propertyCity,
    propertyState,
    tenantName,
    tenantDocument,
    estateName,
    createdAt
  } = claim;
  const [messages, setMessages] = useState<any[]>([]);
  const [totalMessages, setTotalMessages] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);

  const handleMessages = async () => {
    const response = await getMessages(id, page);
    const { data, count } = response;
    setMessages([...data]);
    setTotalMessages(count);
    setIsLoading(false);
  };

  useEffect(() => {
    handleMessages();
  }, [id]);

  const fullAddress = `${propertyStreet}, ${propertyNumber}${
    propertyComplement ? ` ${propertyComplement}` : ''
  } - ${propertyDistrict} - ${propertyCity} - ${propertyState}`;

  return (
    <>
      {isLoading ? (
        <Dimmer active={isLoading} inverted>
          <Loader content="Carregando mensagens..." />
        </Dimmer>
      ) : (
        <>
          <InfoContainer>
            <div>
              <div>
                <strong>Inquilino: </strong>
                <span>
                  {tenantName} ({maskCpfOrCnpj(tenantDocument)})
                </span>
              </div>
            </div>
            <div>
              <div>
                <strong>Imóvel: </strong>
                <span>{fullAddress}</span>
              </div>
            </div>
            <div>
              <div>
                <strong>Imobiliária: </strong>
                <span>{estateName}</span>
              </div>
            </div>
            <div>
              <div>
                <strong>Data de Abertura: </strong>
                <span>{moment(createdAt).format('DD/MM/YYYY')}</span>{' '}
                {/* TODO: TROCAR P/ O CAMPO DE DATA DE ABERTURA QUE DEVERÁ SER CRIADO */}
              </div>
              {/* <div>
                        <strong>Data de Criação: </strong>
                        <span>{moment(claim.createdAt).format('DD/MM/YYYY - HH:mm:ss')}</span>
                      </div>
                      <div>
                        <strong>Data de Atualização: </strong>
                        <span style={{color: Boolean(claim.updatedAt) ? 'default' : '#aeaeae'}}>{claim.updatedAt ? moment(claim.updatedAt).format('DD/MM/YYYY - HH:mm:ss') : 'Não houve atualização'}</span>
                      </div> */}
            </div>
          </InfoContainer>
          {messages.length > 0 ? (
            <FollowUp
              messages={messages}
              id={id}
              isBlocked={props.isBlocked}
              totalMessages={totalMessages}
              page={page}
              setPage={setPage}
            /> // setUnread={setUnread} unread={unread}
          ) : (
            <MessageSender id={id} isBlocked={props.isBlocked} />
          )}
        </>
      )}
    </>
  );
};

export default FollowUpTab;
